import { RunUpdateUserProfileInput, UpdateResponse } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { RunUpdateUserProfileBulkDocument } from '@/api/queries';
import graphApi from '@/api';

type UpdateUserProfileBulkGraphApiResponse = GraphApiResponse<typeof RunUpdateUserProfileBulkDocument>;

const updateUserProfileBulkResponseSelector = (res: UpdateUserProfileBulkGraphApiResponse): UpdateResponse[] =>
  !res.errors ? res?.runUpdateUserProfileBulk?.response || [] : undefined;

const [runUpdateUserProfileBulk] = graphApi(RunUpdateUserProfileBulkDocument);

export const updateUserProfileBulk = async (inputs: RunUpdateUserProfileInput[] = []): Promise<UpdateResponse[]> => {
  const updates: RunUpdateUserProfileInput[] = inputs.length > 0 ? inputs : null;
  const res = await runUpdateUserProfileBulk({ input: { updates } });

  const selected = updateUserProfileBulkResponseSelector(res);

  return selected;
};

export default updateUserProfileBulk;
